// extracted by mini-css-extract-plugin
export default {"app":"styles_app__3FOlS","appStubStyle":"styles_appStubStyle__268NT"};